import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChartBar, FaKey, FaSyncAlt, FaToggleOn, FaUsers } from 'react-icons/fa';
import PageView from '../common/pageView';
import ActivityReport from '../activityReport/activityReport';
import AdminSports from './adminSports';
import AdminUsers from './adminUsers';
import { getAdminKey, setStoredAdminKey } from '../../service/adminKeyService';
import globalStyles from '../globals.module.css';
import componentStyles from './adminPage.module.css';

const ADMIN_SECTIONS = {
    sports: {
        label: 'Sports',
        icon: <FaToggleOn />
    },
    users: {
        label: 'Users',
        icon: <FaUsers />
    },
    activity: {
        label: 'Activity',
        icon: <FaChartBar />
    }
};

const AdminPage = ({ initialSection = 'sports' }) => {
    const [activeSection, setActiveSection] = useState(ADMIN_SECTIONS[initialSection] ? initialSection : 'sports');
    const [adminKeyInput, setAdminKeyInput] = useState(() => getAdminKey());
    const [adminKey, setAdminKey] = useState(() => getAdminKey());
    const [adminKeyVersion, setAdminKeyVersion] = useState(0);

    useEffect(() => {
        setActiveSection(ADMIN_SECTIONS[initialSection] ? initialSection : 'sports');
    }, [initialSection]);

    const handleSaveAdminKey = (event) => {
        event.preventDefault();
        const normalizedAdminKey = String(adminKeyInput || '').trim();
        setStoredAdminKey(normalizedAdminKey);
        setAdminKey(normalizedAdminKey);
        setAdminKeyVersion((prev) => prev + 1);
    };

    const renderHeader = () => (
        <div className={componentStyles.adminHeader}>
            <div className={componentStyles.topRow}>
                <Link to="/home" className={globalStyles.textButton}>Back to app</Link>
                <form className={componentStyles.keyForm} onSubmit={handleSaveAdminKey}>
                    <FaKey className={componentStyles.keyIcon} />
                    <input
                        className={`${globalStyles.standardInput} ${componentStyles.keyInput}`}
                        type="password"
                        value={adminKeyInput}
                        onChange={(event) => setAdminKeyInput(event.target.value)}
                        placeholder="Admin key"
                        aria-label="Admin key"
                    />
                    <button className={globalStyles.secondaryButton} type="submit">
                        Save Key
                    </button>
                </form>
            </div>
            <div className={componentStyles.sectionSwitchRow} aria-label="Admin sections">
                {Object.entries(ADMIN_SECTIONS).map(([sectionKey, section]) => (
                    <button
                        key={sectionKey}
                        type="button"
                        aria-pressed={activeSection === sectionKey}
                        className={`${componentStyles.sectionSwitchButton} ${activeSection === sectionKey ? componentStyles.sectionSwitchButtonActive : ''}`}
                        onClick={() => setActiveSection(sectionKey)}
                    >
                        {section.icon}
                        <span>{section.label}</span>
                    </button>
                ))}
                <button
                    type="button"
                    className={`${globalStyles.iconButton} ${componentStyles.refreshButton}`}
                    onClick={() => setAdminKeyVersion((prev) => prev + 1)}
                    title="Refresh active admin section"
                >
                    <FaSyncAlt />
                    Refresh
                </button>
            </div>
        </div>
    );

    return (
        <PageView
                title="Admin"
                header={renderHeader()}
                containerClassName={componentStyles.adminContainer}
                headerClassName={componentStyles.adminHeaderWrap}
                contentClassName={componentStyles.adminContent}
            >
                {activeSection === 'sports' && <AdminSports refreshToken={adminKeyVersion} />}
                {activeSection === 'users' && <AdminUsers refreshToken={adminKeyVersion} adminKey={adminKey} />}
                {activeSection === 'activity' && <ActivityReport embedded refreshToken={adminKeyVersion} />}
        </PageView>
    );
};

export default AdminPage;
